import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useIntl } from "react-intl";
import { CheckoutPayment } from "@components/organisms";
import { useCheckout } from "@saleor/sdk";
import { commonMessages } from "@temp/intl";

var CheckoutPaymentSubpageWithRef = function CheckoutPaymentSubpageWithRef(_ref, ref) {
  var paymentGatewayFormRef = _ref.paymentGatewayFormRef,
      promoCodeDiscountFormRef = _ref.promoCodeDiscountFormRef,
      inputPromoValue = _ref.inputPromoValue,
      changeSubmitProgress = _ref.changeSubmitProgress,
      setLoadingPromoCode = _ref.setLoadingPromoCode,
      setshowSetPromo = _ref.setshowSetPromo,
      onSubmitSuccess = _ref.onSubmitSuccess,
      onPaymentGatewayError = _ref.onPaymentGatewayError,
      setShowPromoCodeForm = _ref.setShowPromoCodeForm,
      showPromoCodeForm = _ref.showPromoCodeForm,
      pendingPromoCode = _ref.pendingPromoCode,
      setpendingPromoCode = _ref.setpendingPromoCode,
      promoCodeErrors = _ref.promoCodeErrors,
      setPromoCodeErrors = _ref.setPromoCodeErrors,
      handleShowVoucherList = _ref.handleShowVoucherList,
      vouchersData = _ref.vouchersData,
      vouchersLoading = _ref.vouchersLoading,
      props = _objectWithoutProperties(_ref, ["paymentGatewayFormRef", "promoCodeDiscountFormRef", "inputPromoValue", "changeSubmitProgress", "setLoadingPromoCode", "setshowSetPromo", "onSubmitSuccess", "onPaymentGatewayError", "setShowPromoCodeForm", "showPromoCodeForm", "pendingPromoCode", "setpendingPromoCode", "promoCodeErrors", "setPromoCodeErrors", "handleShowVoucherList", "vouchersData", "vouchersLoading"]);

  var _useCheckout = useCheckout(),
      promoCodeDiscount = _useCheckout.promoCodeDiscount,
      addPromoCode = _useCheckout.addPromoCode,
      removePromoCode = _useCheckout.removePromoCode;

  var promoCodeDiscountFormId = "discount-form";
  var intl = useIntl();
  useImperativeHandle(ref, function () {
    return {
      submitPayment: function submitPayment() {
        if ((promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) === null && inputPromoValue && paymentGatewayFormRef.current) {
          setshowSetPromo(true);
        } else if (paymentGatewayFormRef.current) {
          setshowSetPromo(false);
          paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        } else {
          setshowSetPromo(false);
          changeSubmitProgress(false);
          onPaymentGatewayError([{
            message: intl.formatMessage(commonMessages.choosePaymentMethod)
          }]);
        }
      },
      handleSubmitPromoCode: function handleSubmitPromoCode(promoCode) {
        handleAddPromoCode(promoCode);
      }
    };
  });

  var handleAddPromoCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promoCode, notSubmit) {
      var _yield$addPromoCode, dataError, pending, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingPromoCode(true);
              _context.next = 3;
              return addPromoCode(promoCode);

            case 3:
              _yield$addPromoCode = _context.sent;
              dataError = _yield$addPromoCode.dataError;
              pending = _yield$addPromoCode.pending;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                changeSubmitProgress(false);
                setPromoCodeErrors(errors);

                if (pending !== undefined) {
                  setpendingPromoCode(pending);
                }
              } else {
                setPromoCodeErrors([]);
                setshowSetPromo(false);
                changeSubmitProgress(false);
              }

              setLoadingPromoCode(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddPromoCode(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRemovePromoCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(promoCode, notSubmit) {
      var _yield$removePromoCod, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return removePromoCode(promoCode);

            case 2:
              _yield$removePromoCod = _context2.sent;
              dataError = _yield$removePromoCod.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                changeSubmitProgress(false);
                setPromoCodeErrors(errors);
              } else {
                setPromoCodeErrors([]);
                changeSubmitProgress(false);
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRemovePromoCode(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSubmitUnchangedDiscount = function handleSubmitUnchangedDiscount() {
    if (paymentGatewayFormRef.current) {
      paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
        cancelable: true
      }));
    } else {
      changeSubmitProgress(false);
      onPaymentGatewayError([{
        message: intl.formatMessage(commonMessages.choosePaymentMethod)
      }]);
    }
  };

  useEffect(function () {
    localStorage.setItem("flag_address", "true");
    return function () {};
  }, []);
  return React.createElement(CheckoutPayment, _extends({}, props, {
    promoCodeDiscountFormId: promoCodeDiscountFormId,
    promoCodeDiscountFormRef: promoCodeDiscountFormRef,
    promoCodeDiscount: {
      voucherCode: promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode
    },
    addPromoCode: handleAddPromoCode,
    removeVoucherCode: handleRemovePromoCode,
    submitUnchangedDiscount: handleSubmitUnchangedDiscount,
    promoCodeErrors: promoCodeErrors,
    pendingPromoCode: pendingPromoCode,
    setshowSetPromo: setshowSetPromo,
    setpendingPromoCode: setpendingPromoCode,
    setShowPromoCodeForm: setShowPromoCodeForm,
    showPromoCodeForm: showPromoCodeForm,
    paymentGatewayFormRef: paymentGatewayFormRef,
    changeSubmitProgress: changeSubmitProgress,
    onPaymentGatewayError: onPaymentGatewayError,
    inputPromoValue: inputPromoValue,
    handleShowVoucherList: handleShowVoucherList,
    vouchersData: vouchersData,
    vouchersLoading: vouchersLoading
  }));
};

var CheckoutPaymentSubpage = forwardRef(CheckoutPaymentSubpageWithRef);
export { CheckoutPaymentSubpage };